import RLCard from "../../../../../../components/card/RLCard";
import TiCardContent from "../../../../../search/components/ticard/components/TiCardContent";
import { COMPONENT_IDS } from "../../../../consts";
import {
  useGetReportSummary,
  useLocalSampleSummaryParams
} from "../../../../hooks";
import { DESCRIPTIONS } from "../../../layout-editor/consts";
import { Tooltip } from "../common";
import { PDFExport } from "../../@types/PDFExport";

export const THREAT_INTELLIGENCE_CARD_ID =
  "report-summary-threat-intelligence-card";

type Props = PDFExport;

const ThreatIntelligenceCard = ({ isPdfView }: Props) => {
  const { hash, sourceId, relationshipId } = useLocalSampleSummaryParams();

  const { data: reportSummaryData } = useGetReportSummary(
    hash,
    sourceId,
    relationshipId
  );

  return (
    <RLCard
      id={THREAT_INTELLIGENCE_CARD_ID}
      header={
        <RLCard.Header>
          <Tooltip
            placement="top"
            message={DESCRIPTIONS[COMPONENT_IDS.THREAT_INTELLIGENCE]}
          >
            <span>Threat Intelligence</span>
          </Tooltip>
        </RLCard.Header>
      }
      content={
        <RLCard.Content>
          <TiCardContent
            family={reportSummaryData?.threat_name}
            noBorder
            fileTypesPivotsToSearch
            prerenderGraphImage={isPdfView}
          />
        </RLCard.Content>
      }
      data-testid="report_summary_threat_intelligence_card"
    />
  );
};

export default ThreatIntelligenceCard;
